import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlueprintEvent, LazyBlueprintJobs, LazyBlueprintNews, LazyBlueprintPage, LazyContentParagraph, LazyCustomerLogos, LazyEventSetup, LazyEventsCollection, LazyEventsOverview, LazyJobSetup, LazyJobsOverview, LazyNewsArticles, LazyNewsletter, LazyOfferSelection, LazyPrepareNews, LazyArrowRightIcon, LazyArrowSimpleIcon, LazyCalendarIcon, LazyCheckmarkIcon, LazyCopyIcon, LazyCrossIcon, LazyFacebookIcon, LazyFilterIcon, LazyLinkIcon, LazyLinkedinIcon, LazyLocationIcon, LazyPlayIcon, LazyPlusIcon, LazyScrollIndicator, LazySpinIcon, LazyToCalendarIcon, LazyTogglerIcon, LazyTwitterIcon, LazyWatchIcon, LazyLogoIcon, LazyHeroDefault, LazyHeroHome, LazyAccordion, LazyButtonDefault, LazyComponentsLoader, LazyContainer, LazyCopyToClipboardPopup, LazyEventCard, LazyEventListRow, LazyFilter, LazyHome, LazyInputField, LazyJobCard, LazyNewsArticlesTeaser, LazyNewsCard, LazyNewsDetail, LazyOfferSidebar, LazyPagination, LazySocialMediaShares, LazyFooter, LazyLangPicker, LazyNavigation } from '#components'
const lazyGlobalComponents = [
  ["BlueprintEvent", LazyBlueprintEvent],
["BlueprintJobs", LazyBlueprintJobs],
["BlueprintNews", LazyBlueprintNews],
["BlueprintPage", LazyBlueprintPage],
["ContentParagraph", LazyContentParagraph],
["CustomerLogos", LazyCustomerLogos],
["EventSetup", LazyEventSetup],
["EventsCollection", LazyEventsCollection],
["EventsOverview", LazyEventsOverview],
["JobSetup", LazyJobSetup],
["JobsOverview", LazyJobsOverview],
["NewsArticles", LazyNewsArticles],
["Newsletter", LazyNewsletter],
["OfferSelection", LazyOfferSelection],
["PrepareNews", LazyPrepareNews],
["ArrowRightIcon", LazyArrowRightIcon],
["ArrowSimpleIcon", LazyArrowSimpleIcon],
["CalendarIcon", LazyCalendarIcon],
["CheckmarkIcon", LazyCheckmarkIcon],
["CopyIcon", LazyCopyIcon],
["CrossIcon", LazyCrossIcon],
["FacebookIcon", LazyFacebookIcon],
["FilterIcon", LazyFilterIcon],
["LinkIcon", LazyLinkIcon],
["LinkedinIcon", LazyLinkedinIcon],
["LocationIcon", LazyLocationIcon],
["PlayIcon", LazyPlayIcon],
["PlusIcon", LazyPlusIcon],
["ScrollIndicator", LazyScrollIndicator],
["SpinIcon", LazySpinIcon],
["ToCalendarIcon", LazyToCalendarIcon],
["TogglerIcon", LazyTogglerIcon],
["TwitterIcon", LazyTwitterIcon],
["WatchIcon", LazyWatchIcon],
["LogoIcon", LazyLogoIcon],
["HeroDefault", LazyHeroDefault],
["HeroHome", LazyHeroHome],
["Accordion", LazyAccordion],
["ButtonDefault", LazyButtonDefault],
["ComponentsLoader", LazyComponentsLoader],
["Container", LazyContainer],
["CopyToClipboardPopup", LazyCopyToClipboardPopup],
["EventCard", LazyEventCard],
["EventListRow", LazyEventListRow],
["Filter", LazyFilter],
["Home", LazyHome],
["InputField", LazyInputField],
["JobCard", LazyJobCard],
["NewsArticlesTeaser", LazyNewsArticlesTeaser],
["NewsCard", LazyNewsCard],
["NewsDetail", LazyNewsDetail],
["OfferSidebar", LazyOfferSidebar],
["Pagination", LazyPagination],
["SocialMediaShares", LazySocialMediaShares],
["Footer", LazyFooter],
["LangPicker", LazyLangPicker],
["Navigation", LazyNavigation],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
